import cx from 'classnames';
import {
    ButtonLight,
    ButtonStandard,
    CheckBox,
    Dialog,
    Label,
    MultiSelectComboBox,
    ScreenMessagePanelContainer,
    formatMessage,
} from 'cw-ui-core';
import _ from 'lodash';
import { useEffect } from 'react';
import { UPDATE_MFA_DIALOG_CONSTANTS } from 'src/features/users/constants/constants';
import css from './UpdateMfaDialog.scss';
import Locale from 'src/i18n';
import layoutCss from 'src/styles/layout.scss';

const { ADD_METHOD_FLAG, REMOVE_METHOD_FLAG } = UPDATE_MFA_DIALOG_CONSTANTS;

export const UPDATE_MFA_USER_DIALOG = 'UPDATE_MFA_USER_DIALOG';

const UpdateMfaDialog = ({
    onDidMount,
    usersCount = 0,
    onCancel,
    onApply,
    onCheckboxClick,
    isAddMfaSelected,
    isRemoveMfaSelected,
    addMfaList,
    removeMfaList,
    setValueInDropdown,
    selectedAddMfaValue,
    selectedRemoveMfaValue,
}) => {
    useEffect(() => {
        onDidMount();
    }, []);

    const isApplydisabled = () => {
        if (isAddMfaSelected && isRemoveMfaSelected) {
            return _.isEmpty(selectedAddMfaValue) || _.isEmpty(selectedRemoveMfaValue);
        }
        if (isAddMfaSelected) {
            return _.isEmpty(selectedAddMfaValue);
        }
        if (isRemoveMfaSelected) {
            return _.isEmpty(selectedRemoveMfaValue);
        }
        return true;
    };

    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="apply"
            automationName="apply"
            className={css.applyButton}
            value={formatMessage(Locale.apply)}
            onClick={onApply}
            disabled={isApplydisabled()}
        />,
    ];

    return (
        <Dialog
            dialogId={UPDATE_MFA_USER_DIALOG}
            header={formatMessage(Locale.updateMandatoryMfa)}
            buttons={dialogButtons}>
            <div className={cx(css.wrap, layoutCss.podCol)}>
                <ScreenMessagePanelContainer className={css.screenMessage} screenKey={UPDATE_MFA_USER_DIALOG} />
                <Label value={formatMessage(Locale.updateMfaDesc)} className={css.label} />
                <div className={css.userCountText}>{formatMessage(Locale.usersSelected, { usersCount })}</div>
                <div className={css.addMfaWrapper}>
                    <CheckBox
                        className={css.checkbox}
                        text={formatMessage(Locale.addMfa)}
                        onChange={() => onCheckboxClick(ADD_METHOD_FLAG)}
                        value={isAddMfaSelected}
                        disabled={_.isEmpty(addMfaList)}
                    />
                    <Label value={formatMessage(Locale.updateMfaAddDesc)} className={css.label} />
                    <MultiSelectComboBox
                        cwId="addMfaDropDown"
                        automationName="addMfaDropDown"
                        className={css.multiSelectDropdown}
                        items={addMfaList}
                        expandOnClick
                        readOnly
                        value={selectedAddMfaValue}
                        disabled={!isAddMfaSelected}
                        onChange={filter => setValueInDropdown(filter, ADD_METHOD_FLAG)}
                        placeholder={formatMessage(Locale.selectMfaMethod)}
                    />
                </div>
                <CheckBox
                    className={css.checkbox}
                    text={formatMessage(Locale.removeMfa)}
                    onChange={() => onCheckboxClick(REMOVE_METHOD_FLAG)}
                    value={isRemoveMfaSelected}
                    disabled={_.isEmpty(removeMfaList)}
                />
                <Label value={formatMessage(Locale.updateMfaRemoveDesc)} className={css.label} />
                <MultiSelectComboBox
                    cwId="removeMfaDropDown"
                    automationName="removeMfaDropDown"
                    className={css.multiSelectDropdown}
                    items={removeMfaList}
                    expandOnClick
                    readOnly
                    value={selectedRemoveMfaValue}
                    disabled={!isRemoveMfaSelected}
                    onChange={filter => setValueInDropdown(filter, REMOVE_METHOD_FLAG)}
                    placeholder={formatMessage(Locale.selectMfaMethod)}
                />
            </div>
        </Dialog>
    );
};

export default UpdateMfaDialog;
